import {Dispatch, ThunkAction} from '../../../../types/actions';
import {root} from '../../../../store/constants';

export const openReleaseNotes = ():
    ThunkAction => {
    return (dispatch: Dispatch) => {
        root.App.router.navigate(root.App.router.getModalUrl('updates'), {trigger: true});
    }
};
